import { IAgendaItem } from '@/shared/api-client/models/agenda/agenda-item';
import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { ArgumentValidator } from '@/shared/helpers';
import { HierarchyFinder } from '@/shared/helpers/hierarchy-finder';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAgendaHierarchyPropertyBag } from '../../models/agenda-hierarchy-property-bag';
import { AgendaItemFileAttachmentModalOpener } from '../../services/AgendaItemFileAttachmentModalOpener.service';

@Component({
    components: { }
})
export default class AgendaActiveItemViewerComponent extends Vue {

    @Prop() public activityId!: string;

    @Prop() public nodes!: IHierarchyNode<IAgendaItem>[];
    @Prop({default: null}) public agendaHierarchyPropertyBag!: IAgendaHierarchyPropertyBag;
    @Prop() public translations!: { [key: string]: string; };

    public get currentItem(): IHierarchyNode<IAgendaItem> | undefined {

        if (!this.agendaHierarchyPropertyBag) {

            return undefined;
        }

        if (!this.agendaHierarchyPropertyBag.activeAgendaItemId) {
            return undefined;
        }

        const activeAgendaItem = this.agendaHierarchyPropertyBag.activeAgendaItemId;

        return HierarchyFinder.find(this.nodes, (x) => {

            return x.entity.id.toLowerCase() === activeAgendaItem.toLowerCase();
        });
    }

    public get hasFiles(): boolean {

        if (!this.currentItem || !this.currentItem.entity) {
            return false;
        }

        if (this.currentItem.entity.fileArchiveFiles && this.currentItem.entity.fileArchiveFiles.length > 0) {
            return true;
        }

        return false;
    }

    public get fullPositionIndex(): string {

        const currentItem = this.currentItem;

        if (!currentItem) {

            return '';
        }

        const ancestors = HierarchyFinder.findAncestors(this.nodes, currentItem);

        return ancestors
            .sort(x => x.uri.length)
            .map(x => x.entity.itemPosition)
            .join('.');
    }

    public async openFileAttachmentsModal(agendaItem: IHierarchyNode<IAgendaItem>, $event?: MouseEvent): Promise<void> {

        ArgumentValidator.notNullOrEmpty(agendaItem, `agendaItem`);

        if ($event) {

            $event.preventDefault();
        }

        const containerElement = this.$refs.container as Element;

        await AgendaItemFileAttachmentModalOpener.openAsync(containerElement, agendaItem, this.translations);
    }
}